import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import get from 'lodash/get';
import BaseOptionsListContainer from '@configuratorware/configurator-frontendgui/App/Modules/Creator/Containers/OptionsList';
import { switchOptions } from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Actions';

const CustomOptionsListContainer = (props) => {
  const { filteredOptionclassifications, selectedoptionclassification, configuration } = useSelector((state) => state.configurator);
  const dispatch = useDispatch();
  return (
    <BaseOptionsListContainer
      {...props}
      onSelect={async (option)=> {
        if (selectedoptionclassification.identifier === 'control') {
          const selectedControls = get(filteredOptionclassifications.find(oc=> oc.identifier === 'control'), 'selectedoptions', []);
          if (selectedControls && selectedControls.length === 1 && option.amount === 0) {
            const switchOptionData = {
              ['sticker']: {
                identifier: 'sticker_no',
                amount: 1,
                check_results: null,
              },
          };
          await dispatch(switchOptions(configuration, switchOptionData, false, false, true));
          }
        }
       props.onSelect(option);

      }}
    />
  );
};

export default CustomOptionsListContainer;
